module.exports = __webpack_public_path__ + "img/link.cb011963.png";